import React from 'react';

const TemplateStats = ({ templates }) => {
  const stats = {
    total: templates.length,
    active: templates.filter(t => !t.is_paused).length,
    paused: templates.filter(t => t.is_paused).length,
    totalGenerated: templates.reduce((sum, t) => sum + (t.stats?.total_generated || 0), 0),
    generatedThisWeek: templates.reduce((sum, t) => sum + (t.stats?.generated_this_week || 0), 0),
    generatedThisMonth: templates.reduce((sum, t) => sum + (t.stats?.generated_this_month || 0), 0),
  };
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-blue-600">{stats.total}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">Total Templates</div>
      </div>
      
      <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-green-600">{stats.active}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">Active</div>
      </div>
      
      <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-yellow-600">{stats.paused}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">Paused</div>
      </div>
      
      <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-purple-600">{stats.totalGenerated}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">Tasks Generated</div>
      </div>
      
      <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-indigo-600">{stats.generatedThisWeek}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">This Week</div>
      </div>
      
      <div className="bg-gradient-to-br from-pink-50 to-pink-100 border border-pink-200 rounded-lg p-4">
        <div className="text-3xl font-bold text-pink-600">{stats.generatedThisMonth}</div>
        <div className="text-sm text-gray-700 font-medium mt-1">This Month</div>
      </div>
    </div>
  );
};

export default TemplateStats;
